export enum ERealtimeConnectionStatus {
  Connected = "connected",
  Disconnected = "disconnected",
}
